import { render, staticRenderFns } from "./EditRoutes.vue?vue&type=template&id=1c91167a"
import script from "./EditRoutes.vue?vue&type=script&lang=js"
export * from "./EditRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports